const API_URL = process.env.REACT_APP_API_URL;

// ─── The one place the UI asks for dropdown options ───────────────────────────
//
// Every screen fetches its batch/student/course/subject/test/trainer lists
// through here, and the server builds them from a single module. Screens used
// to hit /api/batches or /api/student directly and slice the result themselves,
// which is how rules like "hide inactive records" drifted apart between pages.
//
// Options always arrive as { label, value }, ready for DropDownComponent /
// MultiSelectDropdown.

export const OPTION_SETS = ["batches", "students", "courses", "subjects", "tests", "trainers"];

export const fetchFilterOptions = async (want = [], scope = {}) => {
  const params = new URLSearchParams();
  params.set("want", (Array.isArray(want) ? want : [want]).join(","));
  Object.entries(scope).forEach(([k, v]) => { if (v) params.set(k, v); });

  const res = await fetch(`${API_URL}/api/filter-options?${params.toString()}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || "Failed to load filter options");
  }
  const json = await res.json();
  return json.data || {};
};

// Convenience for the common single-list case.
export const fetchBatchOptions = async (scope = {}) =>
  (await fetchFilterOptions(["batches"], scope)).batches || [];

export const fetchStudentOptions = async (scope = {}) =>
  (await fetchFilterOptions(["students"], scope)).students || [];
